import type { ReactNode } from 'react';

export const symbol_play_lesson: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-79q-24 0-42-18t-18-42v-681q0-24 18-42t42-18h520q24 0 42 18t18 42v305q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-305H462v251q0 8.61-7.5 13.3-7.5 4.7-15.5-.3l-73-45-73 45q-8 5-15.5.3-7.5-4.69-7.5-13.3v-251h-90v681h267q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q459.75-79 447-79H180Zm411.5-16.5Q536-151 536-232t55.5-136.5Q647-424 728-424t136.5 55.5Q920-313 920-232T864.5-95.5Q809-40 728-40T591.5-95.5ZM702-155l100-64q7-4.5 7-12.75T802-245l-100-64q-8-5-15.5-.93-7.5 4.06-7.5 12.93v130q0 8.87 7.5 12.93Q694-150 702-155ZM270-820h192-192Zm-90 681v-681 264.7-45.7 45.7V-820v681Z"
		/>
	</svg>
);
